import { render, staticRenderFns } from "./global-message.vue?vue&type=template&id=26f04fe7&scoped=true&"
import script from "./global-message.vue?vue&type=script&lang=js&"
export * from "./global-message.vue?vue&type=script&lang=js&"
import style0 from "./global-message.vue?vue&type=style&index=0&id=26f04fe7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f04fe7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26f04fe7')) {
      api.createRecord('26f04fe7', component.options)
    } else {
      api.reload('26f04fe7', component.options)
    }
    module.hot.accept("./global-message.vue?vue&type=template&id=26f04fe7&scoped=true&", function () {
      api.rerender('26f04fe7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/common/global-message.vue"
export default component.exports